module.exports = __webpack_public_path__ + "static/media/wave.455616fa.svg";